export enum RotationState {
  START = 'start',
  ROTATE = 'rotate',
  RESET = 'RESET',
  UPDATE_ROTATION_TIME = 'Update_Rotation_Time',
  HOLD = 'hold'
}
